import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from '@app/app.component';
import { Signup } from '@app/_models';
import { SignupService } from '@app/_services';
import { breakpointPixels } from '@fa-switch-sharedservices/ng-elements';

@Component({
  selector: 'app-partner-contact',
  templateUrl: './partner-contact.component.html',
  styleUrls: ['./partner-contact.component.css']
})
export class PartnerContactComponent implements OnInit {

  firstName: string;
  copyTextSize: string;
  welcomeSize: string;
  innerWidth: number = window.innerWidth;
  signup: Signup;
  loading = true;
  constructor(private signupService: SignupService,
    private router: Router,
    private appComponent: AppComponent) { }

  ngOnInit(): void {
    this.handleGetSignup();
    this.handleViewChange();
    this.loading = false;
  }

  handleGetSignup(){
    this.signup = this.signupService.getSignup();
    this.firstName = this.signup.firstName;
    if(this.appComponent.partner == false)
    {
      this.handleRefresh();
    }
    this.signupService.forwardPartner(this.signup).subscribe();

  }

  handleRefresh(){
    this.appComponent.partner = true;
    var logo = this.signup.partner.logoImageContentType + this.signup.partner.logo;
    this.appComponent.partnerLogo = logo; 
  }

  handleViewChange(): void{
    if(this.innerWidth <= breakpointPixels.sm)
    {
      this.copyTextSize = "paragraph-large";
      this.welcomeSize = "heading-large";
    }
    else
    {
      this.copyTextSize = "paragraph-medium";
      this.welcomeSize = "heading-small";
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
    this.handleViewChange();
  }
  
  goHome(){
    sessionStorage.clear();
    this.router.navigate(['/home']);
  }
}
